module.exports = __webpack_public_path__ + "static/img/limit-reward-modal.21bd582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/limit-reward-modal.png
// module id = tjW2
// module chunks = 213